module.exports = __webpack_public_path__ + "static/media/hip-adduction.f4691b2d.svg";